// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"83ef3047","453":"5a1fd437"}[chunkId] + ".chunk.js";
};